import React from "react";
import { Button } from "ui/chakra/components/Button";

type AddToCartButtonProps = {
  onClick: React.MouseEventHandler<HTMLButtonElement>;
};

export const AddToCartButton: React.FC<AddToCartButtonProps> = ({
  onClick,
}) => {
  return (
    // eslint-disable-next-line no-restricted-syntax -- i18n 未対応
    <Button variant="solid" size="sm" onClick={onClick}>
      カートに入れる
    </Button>
  );
};
